export const DefaultFleetEventMotDetailsModel = {
    testNumber: '',
    testLocation: '',
    completedDate: '',
    expiryDate: '',
    odometerReading: 0,
    passed: false,
    defects: []
};

export const DefaultFleetEventModel = {
    name: '',
    eventTypeId: 0,
    statusName: '', 
    vorStartDate: '', 
    vorEndDate: '',
    eventDate: '', 
    startDate: '', 
    completedDate: '', 
    completedUser: '', 
    signoffDate: '', 
    signoffUser: '', 
    signoffUserId: 0, 
    signoffSecondDate: '', 
    signoffSecondUser: '', 
    signoffSecondUserId: 0, 
    comment: '',
    documents: [],
    defects: [],
    costs: [],
    outstandingRequirements: [],
    relatedEvents: [],
    checks: [],
    motDetails: DefaultFleetEventMotDetailsModel
};

export const DefaultEventUpdateRequest = {
    //STEP 1
    eventDate: '',
    moveAssociatedFutureEvents: '',
    eventStatus: '',
    vorStartDate: '',
    vorEndDate: '',
    //STEP 2
    comment: '',
    failed: false,
    //STEP 4
    eventDefects: []
}

export const DefaultStepsConfig = {
    TotalSteps: 0,
    ResheduleEvent: {
        skipStep: false,
        fields: [],
        rules: [],
        stepCompleted: true,
        alwaysMoveFutureEvents: false
    },
    CommentFailEvent: {
        skipStep: true,
        commentIsRequired: false,
        fields: [],
        rules: [],
        addCommentLater: false,
        stepCompleted: false,
    },
    DefectEvent: {
        skipStep: true,
        defectIsRequired: false,
        fields: [],
        rules: [],
        addDefectLater: false,
        hasDefects: false,
        notSignedOffDefect: false,
        signoffDefectLater: false,
        stepCompleted: false,
        onSave: () => null,
        canSave: false
    },
    CostEvent: {
        skipStep: true,
        costIsRequired: false,
        fields: [],
        rules: [],
        addCostLater: false,
        stepCompleted: false,
        onSave: () => null,
        canSave: false
    },
    CostDocumentEvent: {
        skipStep: true,
        documentsAreRequired: false,
        fields: [],
        rules: [],
        addCostDocumentsLater: false,
        stepCompleted: false,
    },
    DocumentEvent: {
        skipStep: true,
        documentsAreRequired: false,
        fields: [],
        rules: [],
        addDocumentsLater: false,
        stepCompleted: false,
    },
    SignoffEvent: {
        skipStep: true,
        signoffRequired: false,
        secondSignoffRequired: false,
        signoffRestricted: false,
        secondSignoffRestricted: false,
        hasBeenSignedOff: false,
        showSecondSignoff: false,
        hasBeenSecondSignedOff: false,
        hasUserAlreadySignedOff: false,
        fields: [],
        rules: [],
        stepCompleted: false,
        signoffLater: false,
        onSignOff: () => null,
        canComplete: false
    },
    CheckEvent: { //This doesn't have a step, but still need the validation
        checkRequired: false,
        checksExist: false
    }
};

export const EventAddLaterOptions = [
    { value: false, label: `Now` },
    { value: true, label: `Later` }
];
